<template>
  <div class="privacy">
      <div class="head">
        <h1>Privacybeleid</h1>
      </div>
      <div class="body">
        <p class="bold">Privacybeleid Enquête Prestatiedatabank</p>
        <p class="text">Bij Prestatiedatabank vinden je privacy belangrijk. Daarom hebben we op een eenvoudige manier in ons privacybeleid opgeschreven hoe we je gegevens verzamelen, gebruiken, vrijgeven, overdragen en bewaren. Al onze medewerkers zijn verplicht om vertrouwelijk met je gegevens om te gaan en hebben een geheimhoudingsplicht.Heb je een vraag over je privacy? Neem contact op met onze Privacy Officer via e-mail op <a href="mailto:support@emviprestatiemeting.nl">support@emviprestatiemeting.nl</a> t.a.v. Privacy Officer of bel 085 80 869 34 (Lokaal tarief)</p>

        <p class="bold">Ik ga akkoord</p>
        <p class="text">Door aan te vinken ‘Met het versturen van dit formulier ga ik ermee akkoord dat Prestatiedatabank mijn persoonsgegevens verwerkt, zoals beschreven in het privacybeleid’ ga je er zonder enige onduidelijkheid akkoord met alles wat in dit privacy beleid staat beschreven, totdat je schriftelijk bij ons aangeeft dit niet meer te willen.</p>

        <p class="bold">Wie is Prestatiedatabank</p>
        <p class="text">Prestatiedatabank is een product van Valk Training & Automatisering B.V., ingeschreven bij de Kamer Van Koophandel met nummer 65444450. Onze opdrachtgevers gebruiken Prestatiedatabank om enquêtes te versturen om informatie te verzamelen over prestaties.</p>
        
        <p class="bold">Welke gegevens we verzamelen en waarom</p>
        <p class="text">Onze opdrachtgever (Verwerkingsverantwoordelijke) wil kunnen aantonen dat de verzamelde gegevens daadwerkelijk door natuurlijke persoonlijk zijn ingevuld. Hierdoor kunnen we je, vóórdat je een enquête invult, vragen de volgende gegevens in te vullen. Deze gegevens voer je zelf in en worden dus niet automatisch verkregen. De mogelijke gegevens die we verzamelen zijn:</p>
        <ul>
          <li>Je naam</li>
          <li>Je e-mailadres</li>
          <li>Je functie</li>
        </ul>
        <p>De organisatie die de enquête verstuurd heeft de mogelijkheid om deze velden te vereisen voordat je de enquête kan invullen. De genoemde gegevens kan onze opdrachtgever als eerste gebruiken om aan te tonen dat je deze informatie heb ingevuld en daarnaast om contact met je op te nemen over de ingevulde informatie.</p>
        
        <p class="bold">Je rechten</p>
        <p class="text">Als je een enquête hebt ingevuld, kan je verzoeken om een exportbestand van je persoonlijke gegevens die we van je hebben, inclusief alle gegevens die je ons opgegeven hebt voor deze enquête. Je kan ook verzoeken dat we alle persoonlijke gegevens die we van je hebben verwijderen. Dit is niet van toepassing op gegevens die we verplicht moeten bewaren in verband met administratieve-, wettelijke- of beveiligingsdoeleinden.Voor een inzage- of verwijderverzoek stuur je een e-mail naar <a href="mailto:support@emviprestatiemeting.nl">support@emviprestatiemeting.nl</a> t.a.v. Privacy Officer. Wij streven ernaar binnen 4 (vier) weken na ontvangst van je verzoek op je verzoek te reageren.</p>
        
        <p class="bold">Heb je een klacht?</p>
        <p class="text">Bij Prestatiedatabank zetten we ons in om je persoonlijke gegevens te beschermen. Mocht je toch een klacht hebben over hoe we je gegevens verzamelen, gebruiken, vrijgeven, overdragen en bewaren, stuur ons een e-mail naar <a href="mailto:support@emviprestatiemeting.nl">support@emviprestatiemeting.nl</a> t.a.v. Privacy Officer. Wij streven ernaar binnen 2 (twee) weken na ontvangst van je klacht op je klacht te reageren. Je hebt ook het recht om een klacht te sturen naar de Autoriteit Persoonsgegevens <a target="_blank" href="https://www.autoriteitpersoonsgegevens.nl/">(bekijk website)</a> nadat je Prestatiedatabank een redelijke termijn de tijd heeft gegeven om op je klacht te reageren. De Autoriteit Persoonsgegevens (AP) is opgericht en aangewezen als toezichthouder op de Algemene Verordening Gegevensbescherming (AVG) en de uitvoeringswet AVG (UAVG).</p>

        <p class="bold">Over deze versie</p>
        <p class="text">We controleren regelmatig of we aan de geldende privacywetgeving en aan onze eigen privacy policy voldoen. Daarom kunnen we ons privacybeleid altijd aanpassen. De laatste en meest actuele versie van ons privacybeleid is altijd via deze pagina te raadplegen. Dit privacybeleid is voor het laatst aangepast op 29 september 2020.</p>

      </div>
      <div class="action">
        <button @click="back">Terug</button>
      </div>
  </div>
</template>

<script>
export default {
    name: 'Privacy',
    data() {
      return {

      }
    },
    methods: {
      back() {
        this.$router.go(-1);
      }
    }
}
</script>

<style scoped>

.head {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  font-weight: 700;
  border-bottom: 1px solid black;
}

.body {
  height: 90%;
  overflow-y: scroll;
  border-bottom: 1px solid black;
  padding: 50px 20%;
}

@media (max-width: 700px) {
  .body {
    padding: 50px 10px;
  }
}

.action {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.privacy {
  padding: 0 30px;
}

button {
  background-color: #00294c;
  border-color: #00294c;
  font-size: 16px;
  font-weight: bold;
  color: white;
  padding-bottom: 8px;
  width: 180px;
  height: 40px;
  transition: width 0.3s;
  border-radius: 290486px;
  cursor: pointer;
}

button:hover {
  background-color: #124572;
  border-color: #124572;
  font-weight: bold;
  color: white;
  padding-bottom: 8px;
  width: 200px;
}

p {
  margin: 10px 0;
}

ul {
  list-style: disc;
  margin-left: 20px;
}
.bold {
  font-weight: 600;
}

</style>


// WEBPACK FOOTER //
// src/components/elements/Privacy.vue